import { useMemo } from 'react';

export const useRemainingTime = (endDate?: string | null) => {
  return useMemo(() => {
    const _endDate = endDate || new Date().toString();
    const time = Math.max(new Date(_endDate).getTime() - new Date().getTime(), 0);
    return {
      days: String(~~(time / 86400000)).padStart(2, '0'),
      hours: String(~~((time % 86400000) / 3600000)).padStart(2, '0'),
      minutes: String(~~((time % 3600000) / 60000)).padStart(2, '0'),
      time,
    };
  }, [endDate]);
};
